import pluralize from "pluralize"
import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"

import ReloadableWidget from "src/components/ReloadableWidget"
import TrackingLink from "src/components/TrackingLink"

import { queryUnassignedReservations } from "src/api/Dashboard"

import DashboardTooltip from "./DashboardTooltip"

const refreshRate = 300 * 1000 // 5 minutes

const renderData = (count) => {
  if (count > 0) {
    return (
      <div className="flex flex-col">
        <div className="mb-2 flex">
          <i className="icon icon-calendar-add-on -mt-1 mr-2 text-2xl" />
          <span className="mr-1 text-xl font-bold">{count}</span>
        </div>
        <span>unassigned {pluralize("reservation", count)}</span>
      </div>
    )
  } else {
    return (
      <div className="flex items-center">
        <i className="icon icon-calendar-add-on -mt-1 mr-2 text-2xl" />
        <span>No unassigned reservations</span>
      </div>
    )
  }
}

const UnassignedReservations = ({ marinaSlug }) => {
  const { isLoading, isError, data } = useQuery(
    ["unassignedReservations", marinaSlug],
    () => queryUnassignedReservations(marinaSlug),
    { retry: false, refetchInterval: refreshRate, refetchOnWindowFocus: false }
  )

  return (
    <ReloadableWidget isLoading={isLoading} isError={isError}>
      {data && (
        <TrackingLink
          href={data.unassignedReservationsLink}
          className="card relative flex w-full items-center justify-between p-6 text-center text-gray-900 no-underline hover:border-blue-800 hover:bg-blue-50 hover:text-blue-700"
          eventName="unassigned_reservations_widget:clicked"
        >
          <DashboardTooltip />
          {renderData(data.unassignedReservationsCount)}
          <i className="icon icon-sf-chevron-right mt-0.5 text-xs font-semibold" />
        </TrackingLink>
      )}
    </ReloadableWidget>
  )
}

UnassignedReservations.propTypes = {
  marinaSlug: PropTypes.string.isRequired,
}

export default UnassignedReservations
